import getConfig from 'next/config';

type Envs = Record<string, string | undefined>;

interface Config {
  env: Envs;
}

// This tool is here to help us retrieve RunTime environment variables
// You expect you can simply use process.env.MYVAR, but those are populated at
// the image BUILD time, but that is agnostic of the environment that image is
// deployed to.
// In order to retrieve variables for the environment the image is deployed in
// you have to use something like getConfig().publicRuntimeConfig but that is
// not supported in pages that do not have SSR. A fallback we introduce is to
// share these variables as a config.js file via our custom server.js that
// can get loaded BEFORE the app is interactive, and can be cached by the client
// here is a blog post detailing the situation:
// https://www.saltycrane.com/blog/2021/04/buildtime-vs-runtime-environment-variables-nextjs-docker

export const getEnv = () => {
  if (
    typeof window !== 'undefined' &&
    typeof (window as { __app_config?: Config }).__app_config?.env !==
      'undefined'
  ) {
    return (window as unknown as { __app_config: Config }).__app_config.env;
  }

  // Fallback
  return getConfig().publicRuntimeConfig as Envs;
};

export default getEnv;
